<template>
  <div class="zch-header">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ZchHeader'
}
</script>